export enum ActivityPointType {
  AttendanceCheck = 'AttendanceCheck',
  ContentFavorite = 'ContentFavorite',
  ProfileFollow = 'ProfileFollow',
  EpisodeRecommend = 'EpisodeRecommend',
  EpisodeReplyRecently = 'EpisodeReplyRecently',
  EpisodeReplyLite = 'EpisodeReplyLite',
  EpisodeReply = 'EpisodeReply',
  EpisodeRead = 'EpisodeRead',
  DesignatedEpisodeRead = 'DesignatedEpisodeRead',
  DesignatedEpisodeReply = 'DesignatedEpisodeReply',
}

export const ActivityPointTypeDisplayList = [
  ActivityPointType.AttendanceCheck,
  ActivityPointType.ContentFavorite,
  ActivityPointType.EpisodeRecommend,
  ActivityPointType.EpisodeReply,
  ActivityPointType.EpisodeReplyRecently,
  ActivityPointType.EpisodeReplyLite,
  ActivityPointType.EpisodeRead,
];
export const ActivityPointTypeString = {
  [ActivityPointType.AttendanceCheck]: '출석체크',
  [ActivityPointType.ContentFavorite]: '작품 좋아요',
  [ActivityPointType.ProfileFollow]: '작가 신작 알림 신청',
  [ActivityPointType.EpisodeRecommend]: '에피소드 추천',
  [ActivityPointType.EpisodeReplyRecently]: '신규 에피소드 댓글',
  [ActivityPointType.EpisodeReplyLite]: '기본 댓글',
  [ActivityPointType.EpisodeReply]: '40자 이상 댓글',
  [ActivityPointType.EpisodeRead]: '에피소드 읽기',
  [ActivityPointType.DesignatedEpisodeRead]: '지정 작품 읽기',
  [ActivityPointType.DesignatedEpisodeReply]: '지정 작품 댓글',
};

export const ActivityPointTypeChanceString = {
  [ActivityPointType.AttendanceCheck]: '',
  [ActivityPointType.ContentFavorite]: '작품당 1번',
  [ActivityPointType.ProfileFollow]: '프로필당 1번',
  [ActivityPointType.EpisodeRecommend]: '에피소드당 1번',
  [ActivityPointType.EpisodeReplyRecently]: '에피소드당 1번',
  [ActivityPointType.EpisodeReplyLite]: '에피소드당 1번',
  [ActivityPointType.EpisodeReply]: '에피소드당 1번',
  [ActivityPointType.EpisodeRead]: '에피소드 읽기',
  [ActivityPointType.DesignatedEpisodeRead]: '',
  [ActivityPointType.DesignatedEpisodeReply]: '',
};
export enum ActivityPointProvideStatus {
  Pending = 'Pending',
  Provided = 'Provided',
  Cancelled = 'Cancelled',
}
export const ActivityPointProvideStatusString = {
  [ActivityPointProvideStatus.Pending]: '대기',
  [ActivityPointProvideStatus.Provided]: '지급',
  [ActivityPointProvideStatus.Cancelled]: '취소',
};

export enum ActivityPointCancelReason {
  PointPolicyNotDefined = 'PointPolicyNotDefined',
  OverLimitPerDay = 'OverLimitPerDay',
  NowEventContent = 'NowEventContent',
  TargetNotFound = 'TargetNotFound',
  UserIsPartner = 'UserIsPartner',
}

export const ActivityPointCancelReasonString = {
  [ActivityPointCancelReason.PointPolicyNotDefined]: '미정의정책',
  [ActivityPointCancelReason.NowEventContent]: '이벤트작품',
  [ActivityPointCancelReason.OverLimitPerDay]: '일일최대치초과',
  [ActivityPointCancelReason.TargetNotFound]: '대상없음',
  [ActivityPointCancelReason.UserIsPartner]: '파트너회원',
};

export enum ActivityPointRewardProvideStatus {
  Waiting = 'Waiting',
  Provided = 'Provided',
}

export enum ActivityPointRankRewardStatus {
  None = 'None',
  Provided = 'Provided',
  Excluded = 'Excluded',
}

export enum ActivityPointRankExcludedType {
  ByReport = 'ByReport',
  ByAdmin = 'ByAdmin',
}

export enum AttendanceCheckParticipateErrorCodes {
  NeedUserCertification = 'NeedUserCertification',
  NeedMarketingAgreement = 'NeedMarketingAgreement',
}

export enum AttendanceCheckMonthStatus {
  InProgress = 'InProgress',
  Filtered = 'Filtered',
  RaffleCompleted = 'RaffleCompleted',
}

export const AttendanceCheckMonthStatusString = {
  [AttendanceCheckMonthStatus.InProgress]: '진행중',
  [AttendanceCheckMonthStatus.Filtered]: '지급 대상 집계 시작',
  [AttendanceCheckMonthStatus.RaffleCompleted]: '지급 완료',
};

export enum AttendanceCheckMonthParticipateStatus {
  Attended = 'Attended',
  NotEnoughCondition = 'NotEnoughCondition',
  NotWin = 'NotWin',
  Win = 'Win',
}
